import { inject } from 'mobx-react';
import propTypes from 'prop-types';

const Pill = ({ type, classNames, label, changeType }) => {
  const _changeType = () => changeType(type);

  return (
    <li className={classNames} onClick={_changeType}>
      {label}
    </li>
  );
};

Pill.propTypes = {
  type: propTypes.string.isRequired,
  classNames: propTypes.string,
  label: propTypes.string.isRequired,
  changeType: propTypes.func.isRequired
};

export default inject((allStores) => ({
  changeType: allStores.uiStore.changeType
}))(Pill);
